var styles = {"loader":"styles_loader__3AMDb relative inline-block","inner":"styles_inner__1s069 absolute top-0 right-0 bottom-0 left-0","spinner-clip":"styles_spinner-clip__3Ijvg","spinnerClip":"styles_spinner-clip__3Ijvg","circle":"styles_circle__1P6Fl absolute top-0 right-0 bottom-0 left-0","spinner-cycle":"styles_spinner-cycle__3sLYB","spinnerCycle":"styles_spinner-cycle__3sLYB"};

export default styles;
//# sourceMappingURL=styles.css.js.map
